import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { FLOW } from '../IDataflow';
import { UnpivotTransformation } from 'app/model/dataflow/unpivottransformation';
import { DataFlowSchemaAdapterUtils } from '../dataflow-schema-adapter-utils';
import { ExpressionBasedColumnVisitorAdapterUtils } from '../expression-based-column-visitor-adapter.utils';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(UnpivotTransformation),
    asynchronous: true
})
export class UnpivotTransformationAdapter extends TransformationAdapter<UnpivotTransformation> {
    public async getDslScript(unpivotTransformation: UnpivotTransformation): Promise<string> {
        const props: string[] = [];
        props.push(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            DataFlowSchemaAdapterUtils.getOutputDefinitionDslForColumns(unpivotTransformation.pivotColumns as any)
        );
        if (unpivotTransformation.groupByColumns.length > 0) {
            props.push(`un${ExpressionBasedColumnVisitorAdapterUtils.getGroupByColumnsDsl(unpivotTransformation)}`);
        }
        if (unpivotTransformation.pivotKeyValues.length && !unpivotTransformation.pickColumnsAsValues) {
            const quotes = unpivotTransformation.unpivotKeyColumn.columnType === 'string' ? `'` : '';
            const values = unpivotTransformation.pivotKeyValues.map((value) => `${quotes}${value}${quotes}`);
            if (unpivotTransformation.nullValue) {
                values.push('null');
            }
            props.push(`pivotValues: [${values.join(', ')}]`);
        }
        props.push(`lateral: ${unpivotTransformation.lateralColumnArrangement}`);
        props.push(`ignoreNullPivots: ${unpivotTransformation.dropNullRows}`);
        const partition = TransformationAdapter.getPartitionDslScript(unpivotTransformation);
        if (partition) {
            props.push(partition);
        }
        const knownProps = `${props.join(',\n\t')}`;
        const unknownProps = this._getUnknownProps(unpivotTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');
        return `${this._getInputStreams(unpivotTransformation)} ${
            UnpivotTransformation.MODEL.name
        }(${transformationData}) ${FLOW} ${this._getOutputStreams(unpivotTransformation)}`;
    }
}
